import { render } from "./SlideHeroItem4.vue?vue&type=template&id=2b16f50c&scoped=true"
import script from "./SlideHeroItem4.vue?vue&type=script&lang=js"
export * from "./SlideHeroItem4.vue?vue&type=script&lang=js"

import "./SlideHeroItem4.vue?vue&type=style&index=0&id=2b16f50c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b16f50c"]])

export default __exports__